const namespace = 'SIGNUP_FORM';

export default {
  FIELD_BLUR: `${namespace}:FIELD_BLUR`,
  FIELD_FOCUS: `${namespace}:FIELD_FOCUS`,
  PASSWORD_INPUT: `${namespace}:PASSWORD_INPUT`,
  SUBMIT_ERROR: `${namespace}:SUBMIT_ERROR`,
};
